import PropTypes from 'prop-types';
import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { applicationSubmit } from '../../actions';

export const SubmitPage = ({ unrecoverableError, dispatchApplicationSubmit }) => {
  useLayoutEffect(() => {
    if (!unrecoverableError) {
      dispatchApplicationSubmit();
    }
  }, [unrecoverableError, dispatchApplicationSubmit]);

  if (unrecoverableError) {
    return <Redirect to="/unrecoverable-error" />;
  }

  return (
    <div className="container container--space-y">
      <header>
        <h1>Submitting application</h1>
      </header>
      Your application is being submitted. Please wait...
    </div>
  );
};

SubmitPage.propTypes = {
  dispatchApplicationSubmit: PropTypes.func.isRequired,
  unrecoverableError: PropTypes.bool.isRequired,
};

export const mapDispatchToProps = {
  dispatchApplicationSubmit: applicationSubmit,
};

export const mapStateToProps = state => ({
  unrecoverableError: state.unrecoverableError,
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitPage);
